import type { Dict } from "./translate";

export const vi: Dict = {
  "lang.choose": "Chọn ngôn ngữ",
  "lang.menu": "Ngôn ngữ",

  "common.optional": "Không bắt buộc",
  "common.select": "Chọn",
  "common.cancel": "Hủy",
  "common.search": "Tìm {label}…",
  "common.noMatches": "Không có kết quả.",
  "common.listSep": ", ",

  "page.subtitle": "Đơn đăng ký dành cho doanh nghiệp",
  "page.referredBy": "Được giới thiệu bởi",
  "page.aBlogicAgent": "một đại lý của BLogic",
  "page.checkingLink": "Đang kiểm tra đường dẫn…",
  "page.linkUnverifiedTitle": "Không kiểm tra được đường dẫn này",
  "page.linkUnverifiedBody": "Hiện chúng tôi chưa xác nhận được đường dẫn đăng ký này. Vui lòng tải lại trang sau giây lát, hoặc nhờ người liên lạc của quý vị tại BLogic giúp đỡ.",
  "page.linkInvalidTitle": "Đường dẫn không hợp lệ",
  "page.linkInvalidBody": "Đường dẫn đăng ký này không còn hiệu lực. Vui lòng xin đường dẫn mới từ người liên lạc của quý vị tại BLogic.",
  "page.missingDl": "Vui lòng thêm ảnh bằng lái xe của quý vị.",
  "page.missingCheck": "Vui lòng thêm ảnh một tấm chi phiếu doanh nghiệp đã hủy (voided check).",
  "page.genericError": "Đã xảy ra lỗi. Vui lòng thử lại.",
  "page.startOverTitle": "Làm lại từ đầu?",
  "page.startOverBody": "Mọi thông tin quý vị đã nhập trên thiết bị này sẽ bị xóa. Thao tác này không thể hoàn tác.",
  "page.submit": "Gửi đơn đăng ký",
  "dup.title": "Có vẻ bạn đã nộp đơn rồi",
  "dup.body": "Chúng tôi đã nhận đơn của {name} vào {date}. Đây có phải cùng một doanh nghiệp không?",
  "dup.same": "Đúng, là cùng một doanh nghiệp — không nộp lại",
  "dup.fix": "Đúng, và tôi cần sửa đơn trước",
  "dup.new": "Không — đây là địa điểm khác",
  "dup.replaceTitle": "Thay thế đơn trước của bạn?",
  "dup.replaceBody": "Đơn mới này sẽ thay thế đơn ngày {date}.",
  "dup.replaceConfirm": "Đúng, thay thế",
  "dup.back": "Quay lại",
  "dup.sameDoneTitle": "Xong rồi",
  "dup.sameDoneBody": "Chúng tôi đã có đơn của bạn. Nhân viên đại diện sẽ liên hệ với bạn.",
  "dup.updatedTitle": "Đã cập nhật — cảm ơn bạn!",
  "dup.updatedBody": "BLogic sẽ xem xét các thay đổi của bạn.",

  "done.title": "Đã nhận đơn đăng ký",
  "done.body": "Cảm ơn quý vị. Nhân viên đại diện của BLogic sẽ sớm liên hệ để xem lại thông tin và hoàn tất việc mở tài khoản.",
  "done.reference": "Mã hồ sơ: {id}",
  "done.another": "Gửi đơn đăng ký khác",

  "step.welcome": "Chào mừng",
  "step.legal": "Pháp lý",
  "step.business": "Kinh doanh",
  "step.owner": "Chủ sở hữu",
  "step.bank": "Ngân hàng",

  "wiz.back": "Quay lại",
  "wiz.continue": "Tiếp tục",
  "wiz.submitting": "Đang gửi…",
  "wiz.saving": "Đang lưu…",
  "wiz.notSaved": "Chưa lưu",
  "wiz.saved": "Đã lưu lúc {time}",
  "wiz.restored": "Đã khôi phục bản nháp quý vị lưu lúc {time}.",
  "wiz.startOver": "Làm lại từ đầu",
  "wiz.tryAgain": "Thử lại",

  "file.prompt": "Chụp ảnh hoặc tải lên",
  "file.scanning": "Đang quét…",
  "file.unsupported": "Loại tệp này không được hỗ trợ",
  "file.uploadedTap": "Tải lên thành công — chạm để thay tệp khác",
  "file.uploadedDrop": "Tải lên thành công — thả tệp mới hoặc chọn tệp để thay",
  "file.dragDrop": "Kéo và thả tệp vào đây, hoặc",
  "file.browse": "chọn tệp",
  "file.limits": "Ảnh hoặc PDF, tối đa {mb} MB",
  "file.previewAlt": "Xem trước {name}",
  "file.attached": "Đã đính kèm: {name}",
  "file.remove": "Xóa",
  "file.typeError": "Loại tệp này không được hỗ trợ. Vui lòng chọn một tệp thuộc loại được hỗ trợ.",
  "file.oneFile": "Mỗi lần chỉ thả một tệp.",
  "file.tooLarge": "Tệp này nặng {size} MB — giới hạn là {max} MB. Vui lòng dùng ảnh nhỏ hơn hoặc bản quét có độ phân giải thấp hơn.",
  "file.reupload": "Vui lòng tải tệp này lên lại.",
  "file.previousLead": "Lần trước quý vị đã đính kèm {name}. Ảnh không được lưu cùng phần tiến trình đã lưu, vì vậy vui lòng đính kèm lại.",
  "file.previousDl": "Họ tên, ngày sinh và địa chỉ bên dưới được lấy từ ảnh đó.",
  "file.previousCheck": "Thông tin ngân hàng bên dưới được lấy từ ảnh đó.",

  "conv.message": "Chúng tôi không xử lý được {names} của quý vị. Chạm vào đây để tải lên lại.",
  "conv.pair": "{a} và {b}",
  "conv.dl": "bằng lái xe",
  "conv.check": "chi phiếu đã hủy",

  "scan.kept": "Đã đính kèm ảnh. Chúng tôi giữ nguyên thông tin quý vị đã nhập.",
  "scan.firstName": "tên",
  "scan.middleName": "tên lót",
  "scan.lastName": "họ",
  "scan.dob": "ngày sinh",
  "scan.address": "địa chỉ",
  "scan.city": "thành phố",
  "scan.state": "tiểu bang",
  "scan.zip": "mã ZIP",
  "scan.routing": "số routing",
  "scan.account": "số tài khoản",
  "scan.bankName": "tên ngân hàng",

  "welcome.title": "Chào mừng quý vị đến với BLogic Systems",
  "welcome.intro": "Cảm ơn quý vị đã chọn hợp tác với chúng tôi. Đơn đăng ký ngắn này là bước đầu tiên để bắt đầu nhận thanh toán. Chỉ mất khoảng 5–10 phút.",
  "welcome.need": "Quý vị cần chuẩn bị",
  "welcome.need1": "Tên pháp lý, EIN (mã số thuế doanh nghiệp) và địa chỉ của doanh nghiệp",
  "welcome.need2": "SSN (số An sinh Xã hội) của chủ sở hữu, hoặc hộ chiếu và quốc gia cấp nếu không phải công dân/thường trú nhân Hoa Kỳ, và địa chỉ nhà",
  "welcome.need3": "Thông tin của chủ sở hữu chính",
  "welcome.need4": "Thông tin tài khoản ngân hàng của doanh nghiệp",
  "welcome.start": "Bắt đầu",

  "legal.title": "Thông tin pháp lý",
  "legal.subtitle": "Xin cho chúng tôi biết về doanh nghiệp của quý vị.",
  "legal.legalName": "Tên công ty / tên pháp lý",
  "legal.email": "Email",
  "legal.phone": "Số điện thoại doanh nghiệp",
  "legal.website": "Trang web",
  "legal.street": "Số nhà, tên đường",
  "legal.zip": "Mã ZIP",
  "legal.state": "Tiểu bang",
  "legal.city": "Thành phố",
  "legal.ownershipType": "Loại hình doanh nghiệp",
  "legal.startDate": "Ngày bắt đầu kinh doanh",
  "legal.ssn": "Số An sinh Xã hội (SSN)",
  "legal.ssnHint": "Chủ doanh nghiệp cá nhân (sole proprietor) cần cung cấp SSN. 9 chữ số, theo dạng XXX-XX-XXXX.",
  "legal.ein": "Mã số thuế doanh nghiệp (EIN)",
  "legal.einHint": "9 chữ số, theo dạng XX-XXXXXXX",
  "legal.dbaTitle": "DBA (tên kinh doanh)",
  "legal.dbaSubtitle": "Tên mà khách hàng thấy, nếu khác với tên pháp lý.",
  "legal.dbaSame": "Tên DBA có giống tên pháp lý không?",
  "legal.dbaYes": "Có, dùng tên pháp lý",
  "legal.dbaNo": "Không, dùng tên DBA khác",
  "legal.dbaName": "Tên kinh doanh (DBA)",
  "legal.dbaNamePlaceholder": "Tên mà khách hàng thấy",

  "biz.title": "Kinh doanh",
  "biz.subtitle": "Thông tin xử lý thẻ của quý vị.",
  "biz.estimates": "Ước tính doanh số qua thẻ",
  "biz.monthly": "Tổng doanh số mỗi tháng ($)",
  "biz.avgTicket": "Số tiền trung bình mỗi giao dịch (ticket) ($)",
  "biz.maxTicket": "Giao dịch lớn nhất ($)",
  "biz.product": "Quý vị bán sản phẩm hoặc dịch vụ gì?",
  "biz.productPlaceholder": "Mô tả ngắn gọn sản phẩm hoặc dịch vụ của quý vị.",

  "owner.title": "Thông tin chủ sở hữu",
  "owner.subtitle": "Chúng tôi xác minh danh tính của chủ sở hữu chính. Quy định của các hãng thẻ yêu cầu tổng tỷ lệ sở hữu ít nhất 51%.",
  "owner.photoLabel": "Chụp ảnh bằng lái xe của quý vị",
  "owner.photoHint": "Chúng tôi sẽ đọc họ tên, ngày sinh và địa chỉ từ ảnh để quý vị khỏi phải gõ. Sau đó vui lòng kiểm tra lại các ô.",
  "owner.reading": "Đang đọc bằng lái…",
  "owner.failed": "Đã xảy ra lỗi khi đọc bằng lái. Vui lòng tự điền các ô bên dưới.",
  "owner.nothingRead": "Không đọc được thông tin nào từ ảnh đó. Vui lòng chụp lại rõ hơn, đủ ánh sáng, hoặc tự điền các ô bên dưới.",
  "owner.prefilled": "Đã điền sẵn {fields}. Vui lòng kiểm tra từng ô và sửa chỗ nào chưa đúng.",
  "owner.citizenship": "Quốc tịch",
  "owner.citizenUs": "Công dân hoặc thường trú nhân Hoa Kỳ",
  "owner.citizenNonUs": "Không phải công dân/thường trú nhân Hoa Kỳ",
  "owner.firstName": "Tên",
  "owner.middle": "Tên lót",
  "owner.lastName": "Họ",
  "owner.dob": "Ngày sinh",
  "owner.jobTitle": "Chức vụ",
  "owner.ssn": "Số An sinh Xã hội (SSN)",
  "owner.ssnHint": "9 chữ số, theo dạng XXX-XX-XXXX",
  "owner.passport": "Số hộ chiếu",
  "owner.passportHint": "Ghi đúng như trên hộ chiếu của chủ sở hữu (chữ và số).",
  "owner.passportCountry": "Quốc gia cấp hộ chiếu",
  "owner.phone": "Số điện thoại",
  "owner.home": "Địa chỉ nhà",

  "bank.title": "Tài khoản ngân hàng doanh nghiệp",
  "bank.subtitle": "Tài khoản để nhận tiền bán hàng qua thẻ (deposit) và trả phí xử lý thẻ.",
  "bank.photoLabel": "Chụp ảnh một tấm chi phiếu doanh nghiệp đã hủy (voided check)",
  "bank.photoHint": "Chúng tôi sẽ đọc số routing và số tài khoản ở phía dưới tấm chi phiếu. Cũng có thể dùng thư xác nhận của ngân hàng có in tiêu đề ngân hàng (letterhead).",
  "bank.reading": "Đang đọc chi phiếu…",
  "bank.failed": "Đã xảy ra lỗi khi đọc chi phiếu. Vui lòng tự nhập số routing và số tài khoản.",
  "bank.nothingRead": "Không đọc được thông tin nào từ ảnh đó. Vui lòng chụp lại rõ hơn, đủ ánh sáng, hoặc tự nhập số routing và số tài khoản.",
  "bank.prefilled": "Đã điền sẵn {fields}. Vui lòng đối chiếu với chi phiếu.",
  "bank.bankName": "Tên ngân hàng",
  "bank.bankNamePlaceholder": "VD: Wells Fargo",
  "bank.routing": "Số routing ngân hàng",
  "bank.routingHint": "9 chữ số.",
  "bank.account": "Số tài khoản",
  "bank.accountPlaceholder": "Số tài khoản checking",
  "bank.accountHint": "Chỉ nhập số, tối đa 17 chữ số.",
  "bank.accountType": "Loại tài khoản",
  "bank.separate": "Dùng tài khoản khác để trừ phí (withdrawal)",
  "bank.withdrawBank": "Tên ngân hàng của tài khoản trừ phí",
  "bank.withdrawType": "Loại tài khoản trừ phí",
  "bank.withdrawRouting": "Số routing của tài khoản trừ phí",
  "bank.withdrawAccount": "Số tài khoản trừ phí",
  "bank.notes": "Ghi chú đặc biệt",
  "bank.notesPlaceholder": "Quý vị có muốn cho chúng tôi biết thêm điều gì không?",
  "bank.notesHint": "Không bắt buộc. Bất cứ điều gì quý vị muốn bộ phận thẩm định (underwriting) biết.",
  "bank.privacy": "Thông tin của quý vị được gửi an toàn và chỉ nhân viên đại diện của BLogic xem xét. Chưa có khoản phí nào bị tính và tài khoản chưa được mở cho đến khi quý vị xác nhận thông tin với nhân viên đó.",

  "v.required": "Vui lòng điền “{label}”.",
  "v.digits": "{label} phải có {n} chữ số.",
  "v.digitsRange": "{label} phải có từ {min} đến {max} chữ số.",
  "v.zip": "{label} phải có 5 chữ số.",
  "v.letters": "{label} chỉ được chứa chữ cái.",
  "v.tooLong": "{label} không được dài quá {max} ký tự.",
  "v.amount": "Vui lòng nhập số tiền hợp lệ.",
  "v.ownershipType": "Vui lòng chọn loại hình doanh nghiệp.",
  "v.emailRequired": "Vui lòng nhập địa chỉ email.",
  "v.emailInvalid": "Vui lòng nhập địa chỉ email hợp lệ.",
  "v.title": "Vui lòng chọn chức vụ.",
  "v.ssnSole": "Doanh nghiệp cá nhân (sole proprietor) bắt buộc phải có SSN.",
  "v.einRequired": "Vui lòng nhập EIN.",
  "v.ssnRequired": "Vui lòng nhập SSN.",
  "v.passportRequired": "Vui lòng nhập số hộ chiếu.",
  "v.passportInvalid": "Vui lòng nhập số hộ chiếu hợp lệ: 5–20 chữ cái hoặc chữ số.",
  "v.passportCountryRequired": "Vui lòng chọn quốc gia cấp hộ chiếu.",
  "v.dbaRequired": "Vui lòng nhập tên DBA, hoặc chọn “{option}”.",

  "lbl.dbaName": "Tên DBA",
  "lbl.addressLine2": "Địa chỉ (dòng 2)",
  "lbl.dbaStreet": "Địa chỉ DBA",
  "lbl.dbaCity": "Thành phố (DBA)",
  "lbl.dbaState": "Tiểu bang (DBA)",
  "lbl.dbaZip": "Mã ZIP (DBA)",
  "lbl.contactName": "Tên người liên hệ",
  "lbl.productDescription": "Mô tả sản phẩm",
  "lbl.middleName": "Tên lót",
  "lbl.idNumber": "Số định danh",
  "lbl.phoneNumber": "Số điện thoại",
  "lbl.mcc": "MCC",
  "lbl.ein": "EIN",
  "lbl.ssn": "SSN",

  "own.Sole Proprietorship": "Doanh nghiệp cá nhân (Sole Proprietorship)",
  "own.Partnership": "Công ty hợp danh (Partnership)",
  "own.General Partnership": "Hợp danh thông thường (General Partnership)",
  "own.Limited Partnership": "Hợp danh hữu hạn (Limited Partnership)",
  "own.Limited Liability Partnership": "Hợp danh trách nhiệm hữu hạn (LLP)",
  "own.LLC": "Công ty TNHH (LLC)",
  "own.Corporation - Private": "Công ty cổ phần tư nhân (Private Corporation)",
  "own.Corporation - Public": "Công ty cổ phần đại chúng (Public Corporation)",
  "own.Professional Association": "Công ty hành nghề chuyên môn (Professional Association)",
  "own.Non-Profit": "Tổ chức phi lợi nhuận (Non-Profit)",
  "own.Political Organization": "Tổ chức chính trị (Political Organization)",
  "own.Government": "Cơ quan chính phủ (Government)",
  "own.Trust": "Quỹ tín thác (Trust)",
  "own.Financial Institution": "Tổ chức tài chính (Financial Institution)",
  "own.Other": "Khác",

  "title.Owner": "Chủ sở hữu",
  "title.Co-Owner": "Đồng chủ sở hữu",
  "title.President": "Chủ tịch (President)",
  "title.Vice President": "Phó chủ tịch (Vice President)",
  "title.Senior Vice President": "Phó chủ tịch cấp cao (Senior Vice President)",
  "title.Secretary": "Thư ký",
  "title.Corporate Secretary": "Thư ký công ty",
  "title.Secretary/Treasurer": "Thư ký/Thủ quỹ",
  "title.CEO": "Tổng giám đốc (CEO)",
  "title.Controller": "Kế toán trưởng (Controller)",
  "title.Financial Officer": "Phụ trách tài chính (Financial Officer)",
  "title.General Manager": "Tổng quản lý (General Manager)",
  "title.General Partner": "Thành viên hợp danh (General Partner)",
  "title.Limited Partner": "Thành viên góp vốn (Limited Partner)",
  "title.Manager": "Quản lý",
  "title.Member": "Thành viên (Member)",
  "title.Director": "Giám đốc (Director)",
  "title.Executive Director": "Giám đốc điều hành (Executive Director)",

  "acct.Checking": "Tài khoản checking",
  "acct.Savings": "Tài khoản tiết kiệm (savings)",
};
